import * as actionTypes from "./actionTypes";
import { signInWithPopup, signOut } from "firebase/auth";
import {
  auth,
  facebookAuthProvider,
  twitterAuthProvider,
} from "../../utils/firebase";
import twitterService from "../../Network/lib/twitterService";
import axios from "axios";
import { store } from "../../store";
import { getAnalytics, logEvent } from "firebase/analytics";
import SecureLS from "secure-ls";
import {
  changeSubscriptionApi,
  changeWaterMarkApi,
  createSubscriptionApi,
  followUserApi,
  getDesoProfileApi,
  postDummyApi,
  selectedTweetsTransferApi,
  TwitterCredApi,
  unsubscribeSubscriptionApi,
  unsubscribeWordApi,
  updateDesoProfileApi,
} from "../../Network/network";
import * as Sentry from "@sentry/react";
import Swal from "sweetalert2";
import { pushGaEvent } from "../../utils/ga_events";

export let identityWindowAction = null;

export let ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "s3cr3tPa$$w0raad@123",
});

const analytics = getAnalytics();

export const twitterLoginStart = () => {
  return {
    type: actionTypes.TWITTER_LOGIN_START,
  };
};

export const twitterLoginSuccess = (user, realodUserInfo) => {
  return {
    type: actionTypes.TWITTER_LOGIN_SUCCESS,
    data: user,
  };
};

export const twitterLoginFail = (error) => {
  return {
    type: actionTypes.TWITTER_LOGIN_FAIL,
    data: error,
  };
};

export const facebookLoginStart = () => {
  return {
    type: actionTypes.FACEBOOK_LOGIN_START,
  };
};
export const wordpressLoginStart = () => {
  return {
    type: actionTypes.WORDPRESS_LOGIN_START,
  };
};

export const facebookLoginSuccess = (user) => {
  return {
    type: actionTypes.FACEBOOK_LOGIN_SUCCESS,
    user: user,
  };
};
export const wordpressLoginSuccess = (user) => {
  return {
    type: actionTypes.WORDPREES_LOGIN_SUCCESS,
    user: user,
  };
};

export const facebookLoginFailure = (error) => {
  return {
    type: actionTypes.FACEBOOK_LOGIN_FAIL,
    error: error,
  };
};
export const wordpressLoginFailure = (error) => {
  return {
    type: actionTypes.WORDPRESS_LOGIN_FAIL,
    error: error,
  };
};

export const WentWrongModal = (
  text = "Something went wrong. Please try again"
) => {
  return Swal.fire({
    icon: "",
    html: text,
    focusConfirm: false,
    confirmButtonText: "ok!",
  }).then(() => {
    window.location.reload(true);
  });
};

export const twitterLogin = () => (dispatch, getState) => {
  pushGaEvent("TWITTER_CONNECT_BUTTON_CLICKED");
  // dispatch(twitterLoginStart());
  signInWithPopup(auth, twitterAuthProvider)
    .then(async (result) => {
      let bodyData = {
        twitter_user_id: result?.user?.providerData?.[0]?.uid,
        access_token_secret: result?._tokenResponse?.oauthTokenSecret,
        access_token: result?._tokenResponse?.oauthAccessToken,
        refresh_token: result?.user?.stsTokenManager?.refreshToken,
      };
      const res = await TwitterCredApi(bodyData);
      ls.set("twitter", result?.user);
      localStorage.setItem(
        "twitter_username",
        result?.user?.reloadUserInfo?.screenName
      );
      dispatch(twitterLoginSuccess(result?.user));

      logEvent(analytics, "twitter_login", {
        user_id: result?.user?.uid,
        user_name: result?.user?.displayName,
      });
    })
    .catch((error) => {
      Sentry.captureException(error);
      dispatch(twitterLoginFail(error));
      logEvent(analytics, "twitter_login_fail", {
        error_message: error.message,
      });
    });
};

export const facebookLogin = () => (dispatch, getState) => {
  dispatch(facebookLoginStart());
  signInWithPopup(auth, facebookAuthProvider)
    .then((result) => {
      dispatch(facebookLoginSuccess(result?.user));
      ls.set("facebook", result?.user);
      logEvent(analytics, "facebook_login", {
        user_name: result?.user?.displayName,
      });
    })
    .catch((error) => {
      Sentry.captureException(error);
      facebookLoginFailure(error);
      logEvent(analytics, "facebook_login_fail", {
        error_message: error.message,
      });
    });
};
export const facebookSignout = () => (dispatch, getState) => {
  signOut(auth)
    .then(() => {
      ls.remove("facebook");
      localStorage.removeItem("facebook_username");
      logEvent(analytics, "facebook_logout", {});
    })
    .catch((error) => {
      Sentry.captureException(error);
      logEvent(analytics, "facebook_logout_fail", {
        error_message: error.message,
      });
    });
};

export const twitterSignOutStart = () => {
  return {
    type: actionTypes.TWITTER_SIGN_OUT_START,
  };
};

export const twitterSignOutSuccess = (user) => {
  return {
    type: actionTypes.TWITTER_SIGN_OUT_SUCCESS,
  };
};

export const twitterSignOutFail = (error) => {
  return {
    type: actionTypes.TWITTER_SIGN_OUT_FAIL,
    data: error,
  };
};
export const setUpdateProfileStateRedux = (data) => {
  return {
    type: actionTypes.UPDATE_PROFILE_STATE,
    value: data,
  };
};
export const setDesoProfileData = (data) => {
  return {
    type: actionTypes.DESO_USER_PROFILE_DATA,
    value: data,
  };
};

export const twitterSignOut = () => (dispatch) => {
  pushGaEvent("TWITTER_SIGNOUT_BUTTON_CLICKED");
  dispatch(twitterSignOutStart());
  signOut(auth)
    .then((result) => {
      dispatch(twitterSignOutSuccess());
      ls.remove("twitter");
      localStorage.removeItem("twitter_username");
      logEvent(analytics, "twitter_logout", {});
    })
    .catch((error) => {
      Sentry.captureException(error);
      dispatch(twitterSignOutFail(error));
    });
};

export const twitterUserData = () => (dispatch) => {
  dispatch(twitterLoginStart());
  dispatch(twitterLoginSuccess(ls.get("twitter")));
};

export const facebookUserData = () => (dispatch) => {
  dispatch(facebookLoginStart());
  dispatch(facebookLoginSuccess(ls.get("facebook")));
};
export const wordPressStart = () => (dispatch) => {
  if (localStorage.getItem("wordpress_info")) {
    dispatch(wordpressLoginStart());
    dispatch(
      wordpressLoginSuccess(JSON.parse(localStorage.getItem("wordpress_info")))
    );
  }
};
export const onAuthChange = () => (dispatch) => {
  // onAuthStateChanged(auth, (user) => {
  //   if (user) {
  //     if (user.providerData[0].providerId === "twitter.com") {
  //       dispatch(twitterLoginSuccess(user));
  //     } else {
  //       dispatch(facebookLoginSuccess(user));
  //     }
  //   } else {
  //     dispatch(twitterLoginFail());
  //   }
  // });
  const desoCred = JSON.parse(localStorage.getItem("credential"));
  const cartData = JSON.parse(localStorage.getItem("cart"));
  if (desoCred !== null) {
    dispatch(desoLoginSuccess(desoCred));
  }
  dispatch(twitterLoginStart());
  dispatch(twitterLoginSuccess(ls.get("twitter")));
  if (cartData !== null) {
    dispatch(setCartStates(cartData));
  }
};

export const setCheckState = (visible) => {
  return {
    type: actionTypes.SET_CHECK,
    data: visible,
  };
};

export const setSelectAllPostState = (visible) => {
  return {
    type: actionTypes.SELECT_ALL_POST,
    data: visible,
  };
};

export const setCartStates = (cart) => {
  return {
    type: actionTypes.CART,
    cart: cart,
  };
};
export const setShowIFrame = (visible) => {
  return {
    type: actionTypes.SET_SHOW_IFRAME,
    showIframe: visible,
  };
};

export const setColorShowState = (visible) => {
  return {
    type: actionTypes.SET_COLOR_SHOW,
    data: visible,
  };
};

export const setModalVisible = (visible) => {
  return {
    type: actionTypes.SET_MODAL_VISIBLE,
    data: visible,
  };
};

export const desoLoginSuccess = (payload) => {
  return {
    type: actionTypes.DESO_LOGIN_SUCCESS,
    data: payload,
  };
};

export const postDataStart = () => {
  return {
    type: actionTypes.POST_DATA_START,
  };
};

export const postDataSuccess = () => {
  return {
    type: actionTypes.POST_DATA_SUCCESS,
  };
};

export const postDataFail = () => {
  return {
    type: actionTypes.POST_DATA_FAIL,
  };
};

export const postDataPartialSuccess = () => {
  return {
    type: actionTypes.POST_DATA_PARTIAL_SUCCESS,
  };
};

export const desoLogin = (payload, signTransaction) => (dispatch, getState) => {
  const {
    auth: { userMetaData },
  } = getState();
  // window.location.href = "/login_twitter";
  dispatch(desoLoginSuccess(payload));
};

export const checking =
  (uid, signTransaction, getJWT, getInfo) => (dispatch, getState) => {
    const {
      auth: { twitter, deso },
    } = getState();
    let user_id = twitter?.user?.providerData[0]?.uid;
    dispatch(
      fetchTwitterUserTimeline(
        user_id,
        deso?.user?.publicKeyAdded,
        deso?.user,
        signTransaction,
        getJWT,
        getInfo
      )
    );
  };

export const setIsDesoBalanceModalState = (visible) => {
  return {
    type: actionTypes.SET_IS_DESO_BALANCE_MODAL,
    data: visible,
  };
};

const fetchTwitterUserTimelineStart = () => {
  return {
    type: actionTypes.FETCH_TWITTER_TIMELINE_START,
  };
};

const fetchTwitterUserTimelineSuccess = (data) => {
  return {
    type: actionTypes.FETCH_TWITTER_TIMELINE_SUCCESS,
    data,
  };
};

const fetchTwitterUserTimelineFail = () => {
  return {
    type: actionTypes.FETCH_TWITTER_TIMELINE_FAIL,
    error: true,
  };
};
export const handleRealTimeSync = (value) => {
  return {
    type: actionTypes.REAL_TIME_SYNC_DATA,
    payload: value,
  };
};
export const setUserMetaData = (value) => {
  return {
    type: actionTypes.SET_USER_META_DATA,
    payload: value,
  };
};
export const setUpdateProfileData = (value) => {
  return {
    type: actionTypes.UPDATE_USER_PROFILE_DATA,
    payload: value,
  };
};
export const setFollowFormData = (value) => {
  return {
    type: actionTypes.FOLLOW_FORM_DATA,
    payload: value,
  };
};
export const handleRealTimeModal = (visible) => {
  return {
    type: actionTypes.REAL_TIME_MODAL,
    realTimeModal: visible,
  };
};
export const handleRealTimeLoading = (visible) => {
  return {
    type: actionTypes.REAL_TIME_LOADING,
    realTimeLoading: visible,
  };
};

export const handleApprove = (value) => {
  return {
    type: actionTypes.HANDLE_APPROVE,
    approve: value,
  };
};

function getJWTFromIdentity(desoUser, publicKey, getJWT) {
  while (true) {
    return new Promise((resolve, reject) => {
      const observer = getJWT({
        accessLevel: desoUser?.users[publicKey]?.accessLevel,
        accessLevelHmac: desoUser?.users[publicKey]?.accessLevelHmac,
        encryptedSeedHex: desoUser?.users[publicKey]?.encryptedSeedHex,
      });
      console.log("observer", observer);
      observer.subscribe((jwt) => {
        console.log("jwt function ", jwt);
        resolve(jwt);
      });
    });
  }
}

function getINFOFromIdentity(getInfo) {
  while (true) {
    return new Promise((resolve, reject) => {
      const observer = getInfo();
      observer.subscribe((payload) => {
        if (payload) {
          resolve(payload);
        } else {
          reject(payload);
        }
      });
    });
  }
}

export const getInfoAction = (getInfo) => (dispatch, getState) => {
  console.log("working");
  const {
    auth: { deso, updateProfileData },
  } = getState();
  let publicKey = deso?.user?.publicKeyAdded;
  let desoUser = deso?.user;
  getINFOFromIdentity(getInfo).then((info) => {
    if (info?.hasStorageAccess) {
      dispatch(setShowIFrame(false));
    } else {
      dispatch(setShowIFrame(true));
    }
  });
};

export const fetchTwitterUserTimeline =
  (id, publicKey, desoUser, signTransaction, getJWT, getInfo) =>
  (dispatch, getState) => {
    dispatch(fetchTwitterUserTimelineStart());
    getINFOFromIdentity(getInfo).then((info) => {
      if (info?.hasStorageAccess) {
        dispatch(setShowIFrame(false));
        getJWTFromIdentity(desoUser, publicKey, getJWT).then((jwt) => {
          if (jwt?.approvalRequired) {
            dispatch(handleApprove(true));
          } else {
            dispatch(handleApprove(false));
            twitterService
              .getTweetsByUserName(id, 5, publicKey, jwt)
              .then((resp) => {
                const {
                  auth: { twitter },
                } = getState();
                const id = twitter?.user?.uid;
                dispatch(postDataStart());

                const reversedTweets = [...resp].reverse();
                uploadToDeso(
                  reversedTweets,
                  publicKey,
                  signTransaction,
                  desoUser
                );
              })
              .catch((error) => {
                Sentry.captureException(error);
                dispatch(fetchTwitterUserTimelineFail(error));
                dispatch(postDataFail());
              });
          }
        });
      }
    });
  };

const pn = window.location.pathname;
export const checkUser =
  (signTransaction, getJWT) => async (dispatch, getState) => {
    const {
      auth: { deso },
    } = getState();
    let publicKey = deso?.user?.publicKeyAdded;
    const res = await getDesoProfileApi({ public_key: publicKey });

    if (pn !== "/profile") {
      if (res?.Profile.Username) window.location.href = "/dashboard";
      else window.location.href = "/profile";
    }
  };

export const updateProfile =
  (signTransaction, getJWT, getInfo) => (dispatch, getState) => {
    const {
      auth: { deso, updateProfileData },
    } = getState();
    let publicKey = deso?.user?.publicKeyAdded;
    let desoUser = deso?.user;
    dispatch(setShowIFrame(false));
    getJWTFromIdentity(desoUser, publicKey, getJWT).then(async (jwt) => {
      let fromData = new FormData();
      fromData.append("public_key", publicKey);
      fromData.append("jwt", jwt.jwt);
      if (updateProfileData?.email) {
        fromData.append("email", updateProfileData?.email);
      }
      if (updateProfileData?.username)
        fromData.append("username", updateProfileData?.username);
      if (updateProfileData?.profile_pic_base64)
        fromData.append(
          "profile_pic_base64",
          updateProfileData?.profile_pic_base64
        );
      if (updateProfileData?.cover_pic)
        fromData.append("cover_pic", updateProfileData?.cover_pic);
      if (updateProfileData?.description)
        fromData.append("description", updateProfileData?.description);
      const res = await updateDesoProfileApi(fromData);

      if (res) {
        const payload = await signTransactionUpdateProfile(
          publicKey,
          signTransaction,
          desoUser,
          res.TransactionHex
        );
        if (payload?.success) {
          dispatch(
            setUpdateProfileStateRedux({
              loading: false,
              step: 3,
              modal: false,
            })
          );
        } else {
          dispatch(
            setUpdateProfileStateRedux({
              loading: false,
              step: 2,
              modal: true,
            })
          );
        }
      } else {
        dispatch(
          setUpdateProfileStateRedux({
            loading: false,
            step: 2,
            modal: true,
          })
        );
      }
    });
  };

export const updateFollow = (signTransaction) => async (dispatch, getState) => {
  const {
    auth: { deso, followFormData },
  } = getState();
  let publicKey = deso?.user?.publicKeyAdded;
  let desoUser = deso?.user;
  const res = await followUserApi(followFormData);

  if (res.TransactionHex) {
    anotherHelpingFunction(
      publicKey,
      signTransaction,
      desoUser,
      res.TransactionHex
    );
  }
};
const anotherHelpingFunction = (
  publicKey,
  signTransaction,
  desoUser,
  TransactionHex
) => {
  signTransactionUpdateFollow(
    publicKey,
    signTransaction,
    desoUser,
    TransactionHex
  );
};

function signTransactionUpdateFollow(
  publicKey,
  signTransaction,
  desoUser,
  TransactionHex
) {
  while (true) {
    return new Promise((resolve, reject) => {
      const extra_data = {
        accessLevel: 4,
        accessLevelHmac: desoUser?.users[publicKey]?.accessLevelHmac,
        encryptedSeedHex: desoUser?.users[publicKey]?.encryptedSeedHex,
        transactionHex: TransactionHex,
      };
      // check of derivedPublicKeyBase58Check key exists in desoUser.users[publicKey]
      if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
        // if not then update the derivedPublicKeyBase58Check key
        extra_data["derivedPublicKeyBase58Check"] =
          desoUser.users[publicKey].derivedPublicKeyBase58Check;
      }
      const observer = signTransaction(extra_data);
      observer.subscribe(async (payload) => {
        if (payload?.approvalRequired) {
          Swal.fire({
            icon: "",
            html: "This transaction needs to be approved. Please press Ok to proceed",
            focusConfirm: false,
            confirmButtonText: "ok!",
          }).then(async () => {
            sessionStorage.setItem("method", "sTranUp");
            identityWindowAction = window.open(
              `https://identity.deso.org/approve?tx=${TransactionHex}`,
              null
            );
          });
          await new Promise((resolve) => {
            const interval = setInterval(() => {
              if (identityWindowAction?.closed) {
                clearInterval(interval);
                resolve();
              }
            }, 1000);
          });
        } else {
          sessionStorage.removeItem("method");
          sessionStorage.setItem(
            "derived-payload",
            payload?.signedTransactionHex
          );
        }
        if (sessionStorage.getItem("derived-payload")) {
          sessionStorage.removeItem("method");
          axios
            .post("https://web3setu.co.in/tweets/submit-transaction", {
              signed_transaction_hex:
                sessionStorage.getItem("derived-payload") ||
                payload?.signedTransactionHex,
            })

            .then(() => {
              resolve(payload);
            })
            .catch(() => reject());
        }
      });
    });
  }
}

function signTransactionUpdateProfile(
  publicKey,
  signTransaction,
  desoUser,
  TransactionHex
) {
  while (true) {
    return new Promise((resolve, reject) => {
      const extra_data = {
        accessLevel: 4,
        accessLevelHmac: desoUser?.users[publicKey]?.accessLevelHmac,
        encryptedSeedHex: desoUser?.users[publicKey]?.encryptedSeedHex,
        transactionHex: TransactionHex,
      };
      // check of derivedPublicKeyBase58Check key exists in desoUser.users[publicKey]
      if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
        // if not then update the derivedPublicKeyBase58Check key
        extra_data["derivedPublicKeyBase58Check"] =
          desoUser.users[publicKey].derivedPublicKeyBase58Check;
      }
      const observer = signTransaction(extra_data);
      observer.subscribe(async (payload) => {
        if (payload?.approvalRequired) {
          Swal.fire({
            icon: "",
            html: "This transaction needs to be approved. Please press Ok to proceed",
            focusConfirm: false,
            confirmButtonText: "ok!",
          }).then(async () => {
            sessionStorage.setItem("method", "sTransUProfile");
            identityWindowAction = window.open(
              `https://identity.deso.org/approve?tx=${TransactionHex}`,
              null
            );
          });
          await new Promise((resolve) => {
            const interval = setInterval(() => {
              if (identityWindowAction?.closed) {
                clearInterval(interval);
                resolve();
              }
            }, 1000);
          });
        } else {
          sessionStorage.removeItem("method");
          sessionStorage.setItem(
            "derived-payload",
            payload?.signedTransactionHex
          );
        }
        if (sessionStorage.getItem("derived-payload")) {
          axios
            .post("https://web3setu.co.in/tweets/submit-transaction", {
              signed_transaction_hex: sessionStorage.getItem("derived-payload"),
            })

            .then(() => {
              resolve({ success: true });
            })
            .catch(() => reject());
        }
      });
    });
  }
}

export const uploadImagesToDeso =
  (signTransaction, getJWT) => (dispatch, getState) => {
    dispatch(twitterLoginStart());
    const {
      auth: { cart, deso },
    } = getState();

    let tweetBodyData = [];
    const desoUser = deso?.user;
    const publicKey = deso?.user?.publicKeyAdded;

    for (let i = 0; i < cart.length; i++) {
      const tweet = tweetBodyData[i];
      const singleCart = cart[i];
      tweetBodyData.push({
        id: singleCart?.id,
        media: singleCart?.media,
        text: singleCart?.text,
      });
    }
    const formData = new FormData();

    dispatch(fetchTwitterUserTimelineStart());
    getJWTFromIdentity(desoUser, publicKey, getJWT).then((jwt) => {
      formData.append("tweets", JSON.stringify(tweetBodyData));
      formData.append("public_key", publicKey);
      formData.append("jwt", jwt);
      twitterService
        .postSelectedTweets(formData)
        .then((resp) => {
          dispatch(postDataStart());
          const cleanedTweets = resp.filter((tweet) => tweet.text);
          uploadToDeso(cleanedTweets, publicKey, signTransaction, desoUser);
        })
        .catch((error) => {
          Sentry.captureException(error);
          console.error(error);
          dispatch(fetchTwitterUserTimelineFail(error));
          dispatch(postDataFail());
        });
    });
  };

let index = 0;
let success = 0;
export const uploadToDeso = (
  tweets,
  publicKey,
  signTransaction,
  desoUser,
  generator
) => {
  if (!generator) {
    generator = upload(tweets[index], publicKey, signTransaction, desoUser);
  }
  let p = generator.next();
  p?.value
    ?.then(() => {
      if (index++ < tweets?.length - 1) {
        uploadToDeso(tweets, publicKey, signTransaction, desoUser);
        success++;
      } else {
        index = 0;
        success = 0;
        store.dispatch(postDataSuccess());
      }
    })
    ?.catch(() => {
      if (success > 0) {
        store.dispatch(postDataPartialSuccess(success));
      } else {
        store.dispatch(postDataFail());
      }
    });
};

function* upload(item, publicKey, signTransaction, desoUser) {
  if (item.text) {
    while (true) {
      yield new Promise((resolve, reject) => {
        axios
          .post("https://web3setu.co.in/tweets/submit-post", {
            public_key: publicKey,
            body: item?.text + "\n\nPosted via @setu_deso",
            image_urls: item?.media,
            min_rate: 1000,
          })
          .then((submitPostResponse) => {
            const observer = signTransaction({
              accessLevel: 4,
              accessLevelHmac: desoUser?.users[publicKey]?.accessLevelHmac,
              encryptedSeedHex: desoUser?.users[publicKey]?.encryptedSeedHex,
              transactionHex: submitPostResponse.data?.TransactionHex,
            });
            observer.subscribe(async (payload) => {
              if (payload?.approvalRequired) {
                identityWindowAction = window.open(
                  `https://identity.deso.org/approve?tx=${submitPostResponse.data?.TransactionHex}`,
                  null
                );
                await new Promise((resolve) => {
                  const interval = setInterval(() => {
                    if (identityWindowAction?.closed) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 1000);
                });
              } else {
                axios
                  .post("https://web3setu.co.in/tweets/submit-transaction", {
                    signed_transaction_hex: payload?.signedTransactionHex,
                  })
                  .then(() => resolve())
                  .catch(() => reject());
              }
            });
          })
          .catch(() => reject());
      });
    }
  }
}

export const helpingFunction =
  (payload, signTransaction, getJWT, getInfo) => (dispatch, getState) => {
    const {
      auth: { deso, realTimeSyncData },
    } = getState();
    const formData = new FormData();
    formData.append("derivedSeedHex", payload.derivedSeedHex);
    formData.append("derivedPublicKey", payload.derivedPublicKeyBase58Check);
    formData.append("publicKeyBase58Check", payload.publicKeyBase58Check);
    formData.append("expirationBlock", payload.expirationBlock);
    formData.append("accessSignature", payload.accessSignature);
    formData.append("jwt", payload.jwt);
    formData.append("derivedJwt", payload.derivedJwt);
    formData.append(
      "transactionSpendingLimitHex",
      payload.transactionSpendingLimitHex
    );
    if (pn === "/wordpress/real_time_sync")
      formData.append("permission_type", "update_profile");
    const value = sessionStorage.getItem("sync_past_tweet");
    getINFOFromIdentity(getInfo).then((info) => {
      console.log("info from 831 line", info);
      if (info?.hasStorageAccess) {
        dispatch(setShowIFrame(false));
        getJWTFromIdentity(deso?.user, deso?.user?.publicKeyAdded, getJWT).then(
          (jwt) => {
            realTimeSyncData.append("jwt", jwt?.jwt);
            const desoUser = deso?.user;
            const publicKey = desoUser?.publicKeyAdded;
            if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
              realTimeSyncData.append(
                "derived_public_key",
                desoUser.users[publicKey].derivedPublicKeyBase58Check
              );
            }
            handleDeriveCallback(
              formData,
              signTransaction,
              deso?.user,
              deso?.user?.publicKeyAdded,
              realTimeSyncData,
              value,
              jwt
            )
              .then((res) => {
                dispatch(handleRealTimeModal(true));
              })
              .catch((error) => {
                // WentWrongModal();
              });
          }
        );
      } else {
        console.log("No Storage Access in 854 line action.js");
        sessionStorage.setItem("storage_granted", "created_subcription");
        dispatch(setShowIFrame(true));
      }
    });
  };

function handleDeriveCallback(
  payload,
  signTransaction,
  desoUser,
  publicKey,
  realTimeSyncData,
  value,
  jwt
) {
  while (true) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "https://web3setu.co.in/real-time-sync/derived-cred-callback",
          payload
        )
        .then((submitPostResponse) => {
          const extra_data = {
            accessLevel: 4,
            accessLevelHmac: desoUser?.users[publicKey]?.accessLevelHmac,
            encryptedSeedHex: desoUser?.users[publicKey]?.encryptedSeedHex,
            transactionHex: submitPostResponse.data?.TransactionHex,
          };
          // check of derivedPublicKeyBase58Check key exists in desoUser.users[publicKey]
          if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
            // if not then update the derivedPublicKeyBase58Check key
            extra_data["derivedPublicKeyBase58Check"] =
              desoUser.users[publicKey].derivedPublicKeyBase58Check;
          }
          const observer = signTransaction(extra_data);
          observer.subscribe(async (payload) => {
            if (payload?.approvalRequired) {
              Swal.fire({
                icon: "",
                html: "This transaction needs to be approved. Please press Ok to proceed",
                focusConfirm: false,
                confirmButtonText: "ok!",
              }).then(async () => {
                sessionStorage.setItem("method", "derived-cred-callback");
                identityWindowAction = await window.open(
                  `https://identity.deso.org/approve?tx=${submitPostResponse.data?.TransactionHex}`,
                  null
                );
              });
              await new Promise((resolve) => {
                const interval = setInterval(() => {
                  if (identityWindowAction?.closed) {
                    clearInterval(interval);
                    resolve();
                  }
                }, 1000);
              });
            } else {
              sessionStorage.removeItem("method");
              sessionStorage.setItem(
                "derived-payload",
                payload?.signedTransactionHex
              );
            }
            if (sessionStorage.getItem("derived-payload")) {
              sessionStorage.removeItem("method");
              axios
                .post("https://web3setu.co.in/tweets/submit-transaction", {
                  signed_transaction_hex:
                    sessionStorage.getItem("derived-payload"),
                })
                .then(() => {
                  console.log("bodySignData working");

                  let bodySignData = {
                    public_key: publicKey,
                    is_signed: 1,
                    jwt: jwt?.jwt,
                  };
                  if (pn === "/wordpress/real_time_sync") {
                    bodySignData["permission_type"] = "update_profile";
                  }
                  if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
                    bodySignData["derived_public_key"] =
                      desoUser.users[publicKey].derivedPublicKeyBase58Check;
                  }
                  console.log("bodySignData", bodySignData);
                  axios
                    .post(
                      "https://web3setu.co.in/real-time-sync/change-sign-status",
                      bodySignData
                    )
                    .then((res) => {
                      if (res.data.status == "success") {
                        if (value == "sync_past_tweet") {
                          axios
                            .post(
                              "https://web3setu.co.in/real-time-sync/selected-tweets-transfer",
                              realTimeSyncData
                            )
                            .then((res) => {
                              resolve({ status: "success" });
                              sessionStorage.setItem("status", "success");
                              localStorage.removeItem("cart");
                            })
                            .catch((err) => {
                              sessionStorage.setItem("status", "fail");
                              let error = { err };
                              let status = error.err?.response?.status;
                              let mgs = error.err?.response?.data?.error;
                              if (status == 400) {
                                reject();
                                WentWrongModal(mgs);
                              } else {
                                WentWrongModal();
                              }
                              Sentry.captureException(err);
                            });
                        } else {
                          let url = "";
                          if (pn == "/wordpress/real_time_sync")
                            url = "wordpress/create-subscription";
                          else if (pn == "/twitter/real_time_sync")
                            url = "real-time-sync/create-subscription";
                          axios
                            .post(
                              `https://web3setu.co.in/${url}`,
                              realTimeSyncData
                            )
                            .then((res) => {
                              resolve({ status: "success" });
                              sessionStorage.setItem("status", "success");
                              sessionStorage.setItem(
                                "real_time_data",
                                JSON.stringify(res.data)
                              );
                            })
                            .catch((err) => {
                              sessionStorage.setItem("status", "fail");
                              let error = { err };
                              let status = error.err?.response?.status;
                              let mgs = error.err?.response?.data?.error;
                              if (status == 400) {
                                reject();
                                WentWrongModal(mgs);
                              } else {
                                WentWrongModal();
                              }
                              Sentry.captureException(err);
                            });
                        }
                      }
                    })
                    .catch((erorr) => {
                      WentWrongModal(
                        "Oops sorry about that, we encountered an error, please unsubscribe and resubscribe after you press the Ok button or after the page refreshes"
                      );
                      Sentry.captureException(erorr);
                    });
                })
                .catch(() => {
                  console.log("error");
                  reject();
                });
            }
          });
        })
        .catch(() => {
          reject();
          WentWrongModal();
        });
    });
  }
}
// export function helpingApi(payload, publicKey, realTimeSyncData, value, jwt) {}

export const withoutDeriveKeySubscibeAction =
  (signTransaction, getJWT, getInfo) => (dispatch, getState) => {
    const {
      auth: { deso, realTimeSyncData },
    } = getState();
    let url = "";
    console.log("path name", pn);

    if (pn == "/wordpress/real_time_sync")
      url = "wordpress/create-subscription";
    else if (pn == "/twitter/real_time_sync")
      url = "real-time-sync/create-subscription";
    console.log("realTimeSyncData", realTimeSyncData);
    getINFOFromIdentity(getInfo).then((info) => {
      if (info?.hasStorageAccess) {
        console.log("info", info);
        getJWTFromIdentity(deso?.user, deso?.user?.publicKeyAdded, getJWT).then(
          async (jwt) => {
            realTimeSyncData.append("jwt", jwt?.jwt);
            const desoUser = deso?.user;
            const publicKey = desoUser?.publicKeyAdded;

            if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
              realTimeSyncData.append(
                "derived_public_key",
                desoUser.users[publicKey].derivedPublicKeyBase58Check
              );
            }
            axios
              .post(`https://web3setu.co.in/${url}`, realTimeSyncData)
              .then((res) => {
                sessionStorage.setItem("status", "success");
                sessionStorage.setItem(
                  "real_time_data",
                  JSON.stringify(res.data)
                );
                dispatch(handleRealTimeModal(true));
              })
              .catch((err) => {
                sessionStorage.setItem("status", "fail");
                let error = { err };
                let status = error.err?.response?.status;
                let mgs = error.err?.response?.data?.error;
                if (status == 400) {
                  WentWrongModal(mgs);
                } else {
                  WentWrongModal();
                }
                Sentry.captureException(err);
              });
          }
        );
      } else {
        dispatch(setShowIFrame(true));
        sessionStorage.setItem("storage_granted", "without_key_subscribe");
      }
    });
  };
export const unsubscribeAction =
  (signTransaction, getJWT, getInfo) => (dispatch, getState) => {
    const {
      auth: { deso, twitter, wordpress },
    } = getState();
    getINFOFromIdentity(getInfo).then((info) => {
      if (info?.hasStorageAccess) {
        getJWTFromIdentity(deso?.user, deso?.user?.publicKeyAdded, getJWT).then(
          async (jwt) => {
            let bodyData = new FormData();
            bodyData.append("public_key", deso?.user?.publicKeyAdded);
            bodyData.append("jwt", jwt?.jwt);

            // TODO: Use this wherever you send JWT
            const desoUser = deso?.user;
            const publicKey = desoUser?.publicKeyAdded;

            // check of derivedPublicKeyBase58Check key exists in desoUser.users[publicKey]
            if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
              // if not then update the derivedPublicKeyBase58Check key
              bodyData.append(
                "derived_public_key",
                desoUser.users[publicKey].derivedPublicKeyBase58Check
              );
            }

            if (pn == "/wordpress/real_time_sync") {
              bodyData.append("wordpress_user_id", wordpress?.user?.user_id);
              bodyData.append("blog_id", wordpress?.user?.blog_id);
            } else if (pn == "/twitter/real_time_sync") {
              bodyData.append(
                "twitter_user_id",
                twitter?.user?.providerData[0]?.uid
              );
            }
            if (pn == "/twitter/real_time_sync") {
              const res = await unsubscribeSubscriptionApi(bodyData);
              if (res.status === "success") {
                localStorage.removeItem("status");
                window.location.reload(true);
              } else {
                WentWrongModal();
              }
            } else if (pn == "/wordpress/real_time_sync") {
              const res = await unsubscribeWordApi(bodyData);
              if (res.status === "success") {
                localStorage.removeItem("status");
                window.location.reload(true);
              } else {
                WentWrongModal();
              }
            }
          }
        );
      } else {
        sessionStorage.setItem("storage_granted", "unsubscribe");
        dispatch(setShowIFrame(true));
      }
    });
  };

export const changeSignAction =
  (signTransaction, getJWT, getInfo) => (dispatch, getState) => {
    const {
      auth: { deso, realTimeSyncData },
    } = getState();
    console.log("realTimeSyncData", realTimeSyncData);
    let url = "";
    if (pn == "/wordpress/real_time_sync")
      url = "wordpress/change-subscription-type";
    else if (pn == "/twitter/real_time_sync")
      url = "real-time-sync/change-subscription-type";
    getINFOFromIdentity(getInfo).then((info) => {
      if (info?.hasStorageAccess) {
        dispatch(setShowIFrame(false));
        getJWTFromIdentity(deso?.user, deso?.user?.publicKeyAdded, getJWT).then(
          async (jwt) => {
            console.log("jwt", jwt);
            realTimeSyncData.append("jwt", jwt?.jwt);
            const desoUser = deso?.user;
            const publicKey = desoUser?.publicKeyAdded;
            if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
              realTimeSyncData.append(
                "derived_public_key",
                desoUser.users[publicKey].derivedPublicKeyBase58Check
              );
            }
            axios
              .post(`https://web3setu.co.in/${url}`, realTimeSyncData)
              .then((res) => {
                if (res?.data?.status === "success") {
                  sessionStorage.setItem("status", "success");
                  sessionStorage.setItem(
                    "real_time_data",
                    JSON.stringify(res?.data)
                  );
                  dispatch(handleRealTimeModal(true));
                } else {
                  sessionStorage.setItem("status", "fail");
                  WentWrongModal();
                }
              })
              .catch((err) => {
                sessionStorage.setItem("status", "fail");
                WentWrongModal();
                Sentry.captureException(err);
              });
          }
        );
      } else {
        sessionStorage.setItem("storage_granted", "change_subscription");
        dispatch(setShowIFrame(true));
      }
    });
  };

export const selectedTweetsTransferAction =
  (signTransaction, getJWT, getInfo) => (dispatch, getState) => {
    const {
      auth: { deso, realTimeSyncData },
    } = getState();
    getINFOFromIdentity(getInfo).then((info) => {
      if (info?.hasStorageAccess) {
        dispatch(setShowIFrame(false));
        getJWTFromIdentity(deso?.user, deso?.user?.publicKeyAdded, getJWT).then(
          async (jwt) => {
            realTimeSyncData.append("jwt", jwt?.jwt);
            const desoUser = deso?.user;
            const publicKey = desoUser?.publicKeyAdded;
            if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
              realTimeSyncData.append(
                "derived_public_key",
                desoUser.users[publicKey].derivedPublicKeyBase58Check
              );
            }
            axios
              .post(
                "https://web3setu.co.in/real-time-sync/selected-tweets-transfer",
                realTimeSyncData
              )
              .then((data) => {
                if (data?.data?.status == "success") {
                  dispatch(handleRealTimeModal(true));
                  sessionStorage.setItem("status", "success");
                  localStorage.removeItem("cart");
                } else {
                  WentWrongModal();
                }
              })
              .catch((err) => {
                sessionStorage.setItem("status", "fail");
                let error = { err };
                let status = error.err?.response?.status;
                let mgs = error.err?.response?.data?.error;
                if (status == 400) {
                  WentWrongModal(mgs);
                } else {
                  WentWrongModal();
                }
                Sentry.captureException(err);
              });
          }
        );
      } else {
        dispatch(setShowIFrame(true));
        sessionStorage.setItem("storage_granted", "selected_tweets_transfer");
      }
    });
  };

export const changeWaterMarkAction =
  (getJWT, getInfo, status) => (dispatch, getState) => {
    const {
      auth: { deso },
    } = getState();
    getINFOFromIdentity(getInfo).then((info) => {
      if (info?.hasStorageAccess) {
        getJWTFromIdentity(deso?.user, deso?.user?.publicKeyAdded, getJWT).then(
          async (jwt) => {
            let bodyData = new FormData();
            bodyData.append("public_key", deso?.user?.publicKeyAdded);
            bodyData.append("status_to_set", status);
            bodyData.append("jwt", jwt?.jwt);

            // TODO: Use this wherever you send JWT
            const desoUser = deso?.user;
            const publicKey = desoUser?.publicKeyAdded;

            // check of derivedPublicKeyBase58Check key exists in desoUser.users[publicKey]
            if (desoUser?.users[publicKey]?.derivedPublicKeyBase58Check) {
              // if not then update the derivedPublicKeyBase58Check key
              bodyData.append(
                "derived_public_key",
                desoUser.users[publicKey].derivedPublicKeyBase58Check
              );
            }
            const res = await changeWaterMarkApi(bodyData);
          }
        );
      }
    });
  };
